import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Button, Dialog, DialogActions, DialogContent, Stack, Typography } from '@mui/material'
import Input from 'common/components/form/Input'
import { BasicDialogTitle } from 'common/components/modal/DialogComponents'

const DialogUpdateLotName = ({
    open,
    lot,
    onClose = () => {},
    onValidate = () => {},
}) => {
    const [name, setName] = useState(lot)
    return (
        <Dialog
            open={open}
            onClose={onClose}
        >
            <BasicDialogTitle onClose={onClose}>{`Modifier le nom du lot ${lot}`}</BasicDialogTitle>
            <DialogContent>
                <Stack margin={1} spacing={1}>
                    <Typography>{'1.[nom du lot] => Lot en cours'}</Typography>
                    <Typography>{'2.[nom du lot] => Lot à venir'}</Typography>
                    <Typography>{'3.[nom du lot] => Lot fermé / archivé'}</Typography>
                </Stack>
                <Input
                    label='Nom du lot'
                    value={name}
                    onChange={setName}
                />
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={() => {
                        onValidate(name)
                        onClose()
                    }}
                    variant='contained'
                    color='primary'
                >
                    Valider
                </Button>
            </DialogActions>
        </Dialog>
    )
}

DialogUpdateLotName.propTypes = {
    lot: PropTypes.string,
    open: PropTypes.bool,
    onClose: PropTypes.func,
    onValidate: PropTypes.func,
}

export default DialogUpdateLotName